module.exports = __webpack_public_path__ + "media/images/official/top_about3-69dcb5bcf140480d2d8449ee8c0a29ae.svg";